import { DEFAULT_LANG } from '@dehaat/kisan-app-bl/constants/common';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useState } from 'react';
import { CLIENT_NAME_COOKIE } from '@/constants/common';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import agcLogo from '@/images/agc-logo.png';
import dehaatEnglishLogo from '@/images/dehaat-en-logo.webp';
import LanguageIcon from '@/images/language.webp';
import { getCookieValue, isAgricentralUser, isDigiAcreUser, isFromSpiceMoney3P } from '@/utils/helper';
import Profile from './navigation/Profile';
const StaticSearchBar = dynamic(() => import('@/components/StaticSearchBar'), {
  ssr: false
});
interface Props {
  containerClassname?: string;
  showCart?: boolean;
  fromApp: boolean;
  isMobile?: boolean;
  isVR?: boolean;
}
const MainHeader = ({
  containerClassname = '',
  fromApp = false,
  isMobile = true,
  isVR = false
}: Props) => {
  const {
    asPath,
    locale
  } = useRouter();
  const {
    t
  } = useTranslation('main');
  const [zIndex, setZIndex] = useState('z-50');
  const isDigiacre = isDigiAcreUser();
  const isFromAgricentral = isAgricentralUser();
  const {
    isEnabled
  } = useFeatureFlags();
  const enableNewSearch = isEnabled('enable_new_search', true);
  const resetZIndex = useCallback(() => {
    setTimeout(() => {
      setZIndex('z-50');
    }, 500);
  }, []);
  return <header className={`bg-white w-full border-[#E6EBF0] border-b ${zIndex} ${containerClassname}`} data-sentry-component="MainHeader" data-sentry-source-file="MainHeader.tsx">
      <nav className="flex flex-col justify-between items-center">
        <div className="flex justify-between items-center px-4 pt-2 pb-2 w-full">
          {isFromAgricentral ? <Link href="/" prefetch={false}>
              <Image alt="Dehaat-logo" src={agcLogo} width={200} height={30} />
            </Link> : fromApp ? <div>
              <Image alt="Dehaat-logo" src={dehaatEnglishLogo} width={95} height={30} />
            </div> : <Link href="/" prefetch={false}>
              <Image alt="Dehaat-logo" src={dehaatEnglishLogo} width={95} height={30} />
            </Link>}
          {(isVR || enableNewSearch) && !isMobile && <StaticSearchBar placeholder={t('search_placeholder')} lang={locale || DEFAULT_LANG} increaseZIndex={() => {
          setZIndex('z-[60]');
        }} resetZIndex={resetZIndex} className="w-full mx-4" />}

          <div className="flex items-center gap-2">
            <Link href={`/language?redirect_uri=${asPath}`} aria-label="Click here to select language" prefetch={false} data-sentry-element="Link" data-sentry-source-file="MainHeader.tsx">
              <Image alt="Select Language" src={LanguageIcon} width={40} height={40} data-sentry-element="Image" data-sentry-source-file="MainHeader.tsx" />
            </Link>

            {(isFromSpiceMoney3P(getCookieValue(CLIENT_NAME_COOKIE)) || !isDigiacre && !fromApp) && <Profile increaseZIndex={() => {
            setZIndex('z-[60]');
          }} resetZIndex={resetZIndex} />}
          </div>
        </div>
      </nav>
    </header>;
};
export default MainHeader;